import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Script from "next/script";
import "./../app/globals.css";
import { SnackbarProvider } from "notistack";
import { AppContextProvider } from "@/appContext";
import { ThemeProvider } from "@mui/material/styles";
import theme from "@/app/theme";
import ResponsiveAppBar from "@/components/Navbar/ResponsiveAppBar";
import { Box } from "@mui/material";
import Footer from "../components/Footer";
import { detectAndSaveGeoPosition } from "@/utils/geolocation";

function MyApp({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    import("@/utils/geolocation").then(({ detectAndSaveGeoPosition }) => {
      detectAndSaveGeoPosition(false); // 👈 disables prompt
    });
  }, []);

  useEffect(() => {
    const enableScroll = () => {
      document.body.style.overflow = "auto"; // ✅ Always allow scrolling
    };

    enableScroll(); // Run once on mount

    const observer = new MutationObserver(() => enableScroll());
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => observer.disconnect(); // Cleanup on unmount
  }, []);

  useEffect(() => {
    // ✅ Fix: Google Analytics Tracking
    const handleRouteChange = (url) => {
      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("config", "G-10NX6JT8S2", {
          page_path: url,
        });
      }
    };
    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Webtunes",
    url: "https://webtunes.com",
    description:
      "Discover live music events and concerts near you with Webtunes! Your go-to guide for upcoming events, featuring details, locations, and everything you need.",
    sameAs: [
      "https://www.facebook.com/WebtunesLive/",
      "https://www.facebook.com/webtunesMD/",
      "https://www.facebook.com/webtunesny/",
      "https://www.instagram.com/webtuneslive",
      "https://x.com/johnfromny",
      "https://youtube/@webtunes",
    ],
    potentialAction: {
      "@type": "SearchAction",
      target: "https://webtunes.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    const currentDate = new Date();
    const month = currentDate.toLocaleString("en-US", { month: "short" }); // force locale
    const year = currentDate.getFullYear();
    setPageTitle(
      `Live Music on Long Island, Annapolis and in Between. Events Concert Guide | Webtunes Near Me ${month} ${year}`
    );
  }, []);

  return (
    <>
      {/* <Script
        strategy="afterInteractive"
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6596539204451830"
        crossOrigin="anonymous"
      /> */}

      {/* <Script
        id="adsbygoogle-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(adsbygoogle = window.adsbygoogle || []).push({});`,
        }}
      />

      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-YOUR_AD_CLIENT_ID"
          data-ad-slot="8925057038"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div> */}

      <SnackbarProvider>
        <ThemeProvider theme={theme}>
          <AppContextProvider>
            <ResponsiveAppBar />
            {/* Main Content */}
            <Box sx={{ paddingTop: "60px", minHeight: "calc(100vh - 150px)" }}>
              <Component {...pageProps} />
              <Script
                strategy="beforeInteractive"
                src="https://www.googletagmanager.com/gtag/js?id=UA-33210947-1"
              />
              <Script id="google-analytics">
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', 'UA-33210947-1');
                  `}
              </Script>
            </Box>
          </AppContextProvider>
        </ThemeProvider>
      </SnackbarProvider>
      <Footer />
    </>
  );
}

export default MyApp;
